import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import * as Actions from '../../store/actions';

import { TextField } from '@material-ui/core';

const styles = theme => ({
    layoutRoot: {},
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200,
    },
    button: {
        margin: theme.spacing.unit,
    },
    expansion: {}
});

class TextAnswer extends Component {

    handleChange = (field_name) => (event) => {
        const { question, updateAnswer } = this.props;

        let value = event.target.value;
        if (event.target.type === 'checkbox') {
            value = event.target.checked ? 1 : 0;
        }

        const update_data = {
            [field_name]: value
        }

        updateAnswer(question.header.question_id, question.answerList[0].header.answer_id, update_data);
    }

    render() {
        const { question, classes, view_type } = this.props;
        
        let answerText = '';
        if(question.answerList.length > 0) {
            answerText = question.answerList[0].header.AnswerText;
        }

        // Short Answer
        if(question.header.question_type_id === 2) {
            return (
                <React.Fragment>
                    <TextField
                        label="Answer Text"
                        className={classes.textField}
                        value={answerText}
                        onChange={this.handleChange('AnswerText')}
                        margin="normal"
                        disabled={view_type === 'detail'}
                        variant="outlined"
                        style={{ width: '80%' }}
                        autoFocus
                    />
                </React.Fragment>
            );
        }

        // Long Answer
        if(question.header.question_type_id === 3) {
            return (
                <React.Fragment>
                    <TextField
                        label="Answer Text"
                        className={classes.textField}
                        value={answerText}
                        onChange={this.handleChange('AnswerText')}
                        margin="normal"
                        disabled={view_type === 'detail'}
                        multiline
                        rows="4"
                        style={{width: '100%'}}
                        variant="outlined"
                        autoFocus
                    />
                </React.Fragment>
            );
        }
    }
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateAnswer: Actions.updateAnswer,
        deleteAnswer: Actions.deleteAnswer,
        moveAnswer:   Actions.moveAnswer,
    }, dispatch);
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(null, mapDispatchToProps)(TextAnswer)));



// WEBPACK FOOTER //
// src/main/content/quiz/quizBuilder/questionType/TextAnswer.js